import { render, staticRenderFns } from "./StatisticsSection.vue?vue&type=template&id=41aa6166&scoped=true"
import script from "./StatisticsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsSection.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41aa6166",
  null
  
)

export default component.exports